export default "__VITE_ASSET__D9Bvh5fy__"